const defaultState = {
    data: {},
    decodedTokenData: {},
    token: '',
    error: false,
    loading: false
};


export default (state = defaultState, action) => {

    switch (action.type) {

        case 'SET_USER_DATA':
            return {...state, data: action.data};

        case 'PATCH_USER_DATA':
            return {...state, data: {...state.data, ...action.data}};

        case 'SET_AUTH_TOKEN':
            return {...state, token: action.data};

        case 'SET_USER_ERROR':
            return {...state, error: action.data};

        case 'SET_USER_LOADING':
            return {...state, loading: action.data};

        case 'UPDATE_TOKEN_DATA':
            return {...state, decodedTokenData: action.data}

        default:
            return state
    }
}
